import { useMutation } from '@tanstack/react-query';
import type { Parameters, RequestBody } from '../../../../../types/typeHelper';
import { useApiClient } from '../../client';

export enum ConnectionsQueryKeys {
  UPDATE_ERP_CUSTOMER_USER = 'UPDATE_ERP_CUSTOMER_USER',
}

export function useUpdateErpCustomerUserMutation() {
  const client = useApiClient();
  return useMutation({
    mutationKey: [ConnectionsQueryKeys.UPDATE_ERP_CUSTOMER_USER],
    mutationFn: async ({
      path,
      body,
    }: {
      path: Parameters<'/admin/connections/{connection_id}/connection-members/{craftsman_id}', 'put'>['path'];
      body: RequestBody<'/admin/connections/{connection_id}/connection-members/{craftsman_id}', 'put'>;
    }) => {
      return client.PUT('/admin/connections/{connection_id}/connection-members/{craftsman_id}', {
        body,
        params: {
          path,
        },
      });
    },
  });
}
